import { getIsRecipient } from 'config/permissions';
import RecipientDashNavbar from './RecipientDashNavbar';
import DonationDashNavbar from './DonationDashNavbar';

interface NavbarProps {
  activeRole: string;
}

export const Navbar = ({ activeRole }: NavbarProps) => {
  if (getIsRecipient(activeRole)) {
    return <RecipientDashNavbar activeRole={activeRole} />;
  }
  return <DonationDashNavbar activeRole={activeRole} />;
};

export default Navbar;
